import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatItalic(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M10 5v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V5h-8Z" fill="currentColor" />
    </BaseIcon>
  );
}
